import Cookies from 'js-cookie';

import { HEADER_CSRF_TOKEN, HEADER_CSRF_TOKEN_RETRY, STATUS_BAD_REQUEST } from './constants';

export const getCookieName = (contextPath: string): string => `${HEADER_CSRF_TOKEN}-${contextPath}`;

const getCsrfHeaderValue = (contextPath: string): string => {
    return Cookies.get(getCookieName(contextPath)) || '';
};

export const getCsrfHeader = (contextPath: string): HeadersInit => {
    return {
        [HEADER_CSRF_TOKEN]: getCsrfHeaderValue(contextPath),
    };
};

export const needsRetry = (response: Response): boolean => {
    if (response.ok || response.status !== STATUS_BAD_REQUEST) return false;
    return !!response.headers.get(HEADER_CSRF_TOKEN_RETRY);
};
